module.exports = __webpack_public_path__ + "img/profile__user_bg.5206363a.png";